// ** UseJWT import to get config
import sanctum from '../../../auth/sanctum/useSanctum';

const config = sanctum.sanctumConfig;

// ** Handle User Login
export const handleLogin = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'LOGIN',
			data,
			config
			//  [config.storageTokenKeyName]: data[config.storageTokenKeyName],
			//  [config.storageRefreshTokenKeyName]: data[config.storageRefreshTokenKeyName]
		});

		// ** Add to user, accessToken & refreshToken to localStorage
		localStorage.setItem('userData', JSON.stringify(data));
		//comentamos tokens y solo seteamos userData obtenido de sanctum
		//localStorage.setItem(config.storageTokenKeyName, JSON.stringify(data.accessToken))
		//localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(data.refreshToken))
	};
};

// ** Handle User Logout
export const handleLogout = (sanctumLogout = true) => {
	return (dispatch) => {
		dispatch({
			type: 'LOGOUT',
			[config.storageTokenKeyName]: null,
			[config.storageRefreshTokenKeyName]: null
		});

		// ** Remove user, accessToken & refreshToken from localStorage
		localStorage.removeItem('userData');
		sanctum.logout();
		//localStorage.removeItem(config.storageTokenKeyName)
		//localStorage.removeItem(config.storageRefreshTokenKeyName)
	};
};
